export default "__VITE_ASSET__D33zDJ$Y__"